import React from "react";
import PropTypes from "prop-types";
import StarRating from "common/components/star_rating";

const StarRatingPartial = ({ rating }) => {
  let percentage = (parseFloat(rating) * 100) / 5;
  /* make sure small star portions are visible */
  let remainder = percentage % 20;
  if (remainder > 0 && remainder < 5) {
    remainder = 5;
  } else if (remainder > 14 && remainder < 20) {
    remainder = 14;
  }
  percentage = Math.floor(percentage / 20) * 20 + remainder;

  return (
    <div className="star-rating-partial">
      <div
        className="full-rating-wrapper"
        style={{ width: `calc(${percentage}% + 0.5px)` }}
      >
        <StarRating initialRate={5} readonly={true} extraClasses="xl" />
      </div>
      <StarRating initialRate={0} readonly={true} extraClasses="xl" />
    </div>
  );
};

StarRatingPartial.propTypes = {
  rating: PropTypes.number.isRequired,
};

export default StarRatingPartial;
